import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
        px: 2,
      }}
    >
      <Typography variant="h3" fontWeight={800}>
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary">
        The page you’re looking for doesn’t exist or has moved.
      </Typography>
      <Button variant="contained" component={RouterLink} to="/">
        Go home
      </Button>
    </Box>
  );
}
